import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bba-colleges-nagpur',
  templateUrl: './bba-colleges-nagpur.component.html',
  styleUrls: ['./bba-colleges-nagpur.component.scss']
})
export class BbaCollegesNagpurComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
